import React from 'react';
import { useMonitoring } from '../context/MonitoringContext';
import ReleasePanel from '../components/ReleasePanel';

export default function Packages() {
    const {
        hoPkg,
        dsPkg,
        ssPkg,
        groups,
        handleUpload,
        triggerDeploy,
        triggerDeployGroup,
        triggerRollback,
    } = useMonitoring();

    return (
        <>
            <header className="dashboard-header">
                <div className="dashboard-title-area">
                    <h1>Package Release Hub</h1>
                    <p>Manage software versions, upload binaries, and deploy packages.</p>
                </div>
            </header>

            <div className="portal-stack">
                <ReleasePanel
                    hoPkg={hoPkg}
                    dsPkg={dsPkg}
                    ssPkg={ssPkg}
                    onUpload={handleUpload}
                    onDeploy={triggerDeploy}
                    onDeployGroup={triggerDeployGroup}
                    onRollback={triggerRollback}
                    groups={groups}
                />
            </div>
        </>
    );
}